module.exports = __webpack_public_path__ + "static/media/pickupOrder.8132b475.svg";